export const lostOrFinishedUserSession = (store: {
	triggerSessionRelod: any
	setInfoModalConfig: any
}) => {
	sessionStorage.removeItem("user")
	store.triggerSessionRelod()
	store.setInfoModalConfig({
		type: "warning",
		titleKey: "user.end-session",
		descriptionKey: "user.end-session-renewing",
		showDuration: 5000,
	})
}